import script from "./comInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./comInfo.vue?vue&type=script&setup=true&lang=js"

import "./comInfo.vue?vue&type=style&index=0&id=7240f3bc&lang=sass&scoped=true"
import "./comInfo.vue?vue&type=style&index=1&id=7240f3bc&lang=scss&scoped=true"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7240f3bc"]])

export default __exports__